import { call, put, select, take, takeLatest } from 'redux-saga/effects';

import cartApi from '@elab/core/store/cart/api';
import { selectors as cartSelectors, types as cartTypes } from '@elab/core/store/cart';
import { selectors as userSelectors, types as userTypes } from '@elab/core/store/user';
import logger from '@elab/core/utils/logger';
import { actions as globalActions } from '@elab/core/store/global';
import isEmpty from '@elab/core/utils/isEmpty';

import selectors from './selectors';
import actions from './actions';
import types from './types';
import api from './api';

export function* loadAddresses() {
    try {
        let userId = yield select(userSelectors.getUserId);
        const cartData = yield select(cartSelectors.getData);

        if (!userId) {
            yield take(userTypes.SET_PROFILE);
            userId = yield select(userSelectors.getUserId);
        }

        const data = yield call(api.getCustomerAddress, userId);

        if (isEmpty(cartData)) {
            yield take(cartTypes.SET_CART_DATA);
        }

        const currentCartDeliveryAddress = yield select(cartSelectors.getDeliveryAddress);
        yield put(
            actions.setAddresses({
                defaultAddressId: currentCartDeliveryAddress.id,
                addresses: data.addresses,
            }),
        );
    } catch (e) {
        yield call(logger.error, e);
    }
}

export function* loadBillingAddresses() {
    try {
        let userId = yield select(userSelectors.getUserId);
        const cartData = yield select(cartSelectors.getData);

        if (!userId) {
            yield take(userTypes.SET_PROFILE);
            userId = yield select(userSelectors.getUserId);
        }
        const data = yield call(api.getCustomerBillingAddress, userId);

        if (isEmpty(cartData)) {
            yield take(cartTypes.SET_CART_DATA);
        }

        const currentCartPaymentAddress = yield select(cartSelectors.getPaymentAddress);
        yield put(
            actions.setAddresses({
                defaultAddressId: currentCartPaymentAddress.id,
                addresses: data.addresses,
            }),
        );
    } catch (e) {
        yield call(logger.error, e);
    }
}

export function* onPutDeliveryAddress({ payload }) {
    const addressId = yield select(selectors.getStoredAddressId);
    yield call(putDeliveryAddress, addressId);
    yield put(globalActions.redirect(payload.successRedirectUrl));
}

export function* onPutBillingAddress({ payload }) {
    const addressId = yield select(selectors.getStoredAddressId);
    yield call(putBillingAddress, addressId);
    yield put(globalActions.redirect(payload.successRedirectUrl));
}

export function* putBillingAddress(addressId) {
    try {
        const userId = yield select(userSelectors.getUserId);
        const cartId = yield select(cartSelectors.getCartId);
        yield call(cartApi.putBillingAddress, userId, cartId, addressId);
    } catch (e) {
        yield call(logger.error, e);
    }
}

export function* putDeliveryAddress(addressId) {
    try {
        const userId = yield select(userSelectors.getUserId);
        const cartId = yield select(cartSelectors.getCartId);
        yield call(cartApi.putDeliveryAddress, userId, cartId, addressId);
    } catch (e) {
        yield call(logger.error, e);
    }
}

export default () => [
    takeLatest(types.LOAD_ADDRESSES, loadAddresses),
    takeLatest(types.LOAD_BILLING_ADDRESSES, loadBillingAddresses),
    takeLatest(types.PUT_DELIVERY_ADDRESS, onPutDeliveryAddress),
    takeLatest(types.PUT_BILLING_ADDRESS, onPutBillingAddress),
];
